import { DeleteReason, IAPIResponse } from "~/api/types";

const API_BASE = "https://apines.hktemas.com/api";

export default class Client {
  public static async getImageTask(
    optionsCount: number = 8
  ): Promise<IAPIResponse> {
    const response = await fetch(
      `${API_BASE}/image-tasks?optionsCount=${optionsCount}&getJson=1`
    );

    return await response.json();
  }

  public static async submitImageTask(
    optionId: string,
    mainImageId: string,
    discardImageIds: string[]
  ): Promise<boolean> {
    const body = new URLSearchParams();
    body.append("option_id", optionId.toString());
    body.append("main_image_id", mainImageId.toString());
    body.append("delete_images", discardImageIds.join(","));

    await fetch(`${API_BASE}/image-tasks`, {
      body,
      method: "post",
      redirect: "manual"
    });

    return true;
  }

  public static async deleteImageTask(
    productId: string,
    reason?: DeleteReason
  ): Promise<boolean> {
    const body = new URLSearchParams();
    body.append("product_id", productId.toString());
    body.append("reason", this.mapDeleteReason(reason));

    try {
      await fetch(`${API_BASE}/image-tasks/delete`, {
        body,
        method: "post",
        redirect: "manual"
      });
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error);
      // Ignore error, because it tries to redirect to the page but this always fails.
    }

    return true;
  }

  private static mapDeleteReason(reason?: DeleteReason): string {
    switch (reason) {
      case DeleteReason.LEGAL_TO_SELL:
        return "legal to sell";

      default:
        return "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/client.ts